import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { ProgramService } from '../program.service';
import { GlobalErrorHandlerService } from '../../services/global-error.service';
import { UserService } from '../../services/user.service';
import { DashboardData } from "./dashboard-data";
import { TabsService } from "../../services/tabs.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-program-dashboard',
  templateUrl: './program-dashboard.component.html',
  styleUrls: ['./program-dashboard.component.scss']
})
export class ProgramDashboardComponent implements OnInit {
  public filter: Object = { year: '', month: '' };
  selected_type = 'month';
  data_available = true;
  duration = 3;
  public lineChartOptions: any = {
    maintainAspectRatio: false,
    responsive: true, legend: { position: 'bottom' }, scales: {
      yAxes: [{ ticks: {} }]
    }, tooltips: { mode: 'label' },
    layout: { padding: { left: 0 }, margin: { left: 0 } }
  };

  public lineChartData: any[] = [];
  public lineChartLabels: any[] = [];
  public lineChartType = 'line';
  public dashboardData: DashboardData = {} as DashboardData;
  public cmsData: any[] = [];
  public privateTableData: any[] = [];
  showTab = 'alerts';
  public selectMonth: any = new Date();
  public maxDate: any = new Date();
  public alertId: string | null = null;

  private cmsDataLoading     = false;
  private graphDataLoaded    = false;
  private cmsDataLoaded      = false;
  private dashboardDataReady = false;
  private alertsReady        = false;

  public randomizeType(): void {
    this.lineChartType = this.lineChartType === 'line' ? 'bar' : 'line';
  }

  public chartClicked(e: any): void { console.log(e); }
  public chartHovered(e: any): void { console.log(e); }

  change_duration(type, from_type?) {
    if (from_type && this.selected_type == type) { return; }
    this.selected_type = type;
    this.loaderService.show();
    this.programService.programme_graph_data({ months: this.duration, type: this.selected_type }).then(data => {
      this.data_available = false;
      this.lineChartData = data.data;
      this.lineChartLabels = data.keys;
      setTimeout(() => { this.data_available = true; }, 200);
      this.loaderService.hide();
    }).catch(resp => {
      this.loaderService.hide();
      this.globalErrorHandlerService.error = resp.error.error;
    });
  }

  constructor(public loaderService: LoaderService, public programService: ProgramService,
              public globalErrorHandlerService: GlobalErrorHandlerService, public userService: UserService,
              public tabsService: TabsService,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.tabsService.register('Program Dashboard');
    this.route.queryParams.subscribe(params => {
      this.alertId = params['id'] || null;
    });
    this.loaderService.show();
    this.programService.getDashboardData().then(resp => {
      this.dashboardData = resp;
      this.dashboardDataReady = true;
      this.tryHideLoader();
    }).catch(resp => {
      this.loaderService.hide();
      this.globalErrorHandlerService.error = resp.error.error;
    });
  }

  onAlertsLoaded(): void {
    this.alertsReady = true;
    this.tryHideLoader();
  }

  private tryHideLoader(): void {
    if (this.dashboardDataReady && this.alertsReady) {
      this.loaderService.hide();
    }
  }

  switchTab(tab: string): void {
    this.showTab = tab;
    if (tab === 'byProgram' && !this.cmsDataLoaded) {
      this.cmsDataLoaded = true;
      this.setMonthAndYear();
    } else if (tab === 'overTime' && !this.graphDataLoaded) {
      this.graphDataLoaded = true;
      this.loaderService.show();
      this.programService.programme_graph_data({ months: this.duration, type: this.selected_type }).then(data => {
        this.data_available = false;
        this.lineChartData = data.data;
        this.lineChartLabels = data.keys;
        setTimeout(() => { this.data_available = true; }, 200);
        this.loaderService.hide();
      }).catch(resp => {
        this.loaderService.hide();
        this.globalErrorHandlerService.error = resp.error.error;
      });
    }
  }

  getCMSData() {
    if (this.cmsDataLoading) { return; }
    this.cmsDataLoading = true;
    this.loaderService.show();
    this.cmsData = [];
    this.privateTableData = [];
    this.programService.getCMSData(this.filter).then(resp => {
      this.cmsData = resp.cms;
      this.privateTableData = resp.private_programme;
      this.cmsDataLoading = false;
      this.loaderService.hide();
    }).catch(resp => {
      this.cmsDataLoading = false;
      this.loaderService.hide();
      this.globalErrorHandlerService.error = resp.error.error;
      console.log(resp);
    });
  }

  setMonthAndYear(e?) {
    this.filter['year'] = new Date(this.selectMonth).getFullYear();
    this.filter['month'] = new Date(this.selectMonth).getMonth() + 1;
    this.getCMSData();
    return this;
  }
}
